import { ThreeCardShareScreen } from '@/screens/three-card-poker/ThreeCardShareScreen'

export default function () {
  return <ThreeCardShareScreen />
}
